"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var context_1 = require("../store/context");
var useDebuggerHook = function (key, value) {
    var _a;
    var _b = (0, context_1.useStore)(), debuggerProps = _b.debuggerProps, setDebuggerProp = _b.setDebuggerProp;
    (0, react_1.useEffect)(function () {
        setDebuggerProp({ key: key, value: value });
    }, [key, value]);
    return (_a = debuggerProps.find(function (p) { return p.key === key; })) === null || _a === void 0 ? void 0 : _a.value;
};
exports.default = useDebuggerHook;
//# sourceMappingURL=index.js.map